/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafetyMessageCreate
 */
export interface SafetyMessageCreate {
    /**
     * 
     * @type {string}
     * @memberof SafetyMessageCreate
     */
    body: string;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyMessageCreate
     */
    active: boolean;
}

/**
 * Check if a given object implements the SafetyMessageCreate interface.
 */
export function instanceOfSafetyMessageCreate(value: object): value is SafetyMessageCreate {
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function SafetyMessageCreateFromJSON(json: any): SafetyMessageCreate {
    return SafetyMessageCreateFromJSONTyped(json, false);
}

export function SafetyMessageCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafetyMessageCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
        'active': json['active'],
    };
}

export function SafetyMessageCreateToJSON(json: any): SafetyMessageCreate {
    return SafetyMessageCreateToJSONTyped(json, false);
}

export function SafetyMessageCreateToJSONTyped(value?: SafetyMessageCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
        'active': value['active'],
    };
}

